import "./style.scss";

import {
  Box,
  Button,
  SpaceBetween,
  Toggle,
} from "@amzn/awsui-components-react-v3";
import React, { useContext } from "react";

import { AppStateContext } from "../../state/provider";

interface SettingsPanelProps {
  onDismiss: () => void;
}

export function SettingsPanel(props: SettingsPanelProps): JSX.Element {
  const appState = useContext(AppStateContext);

  const onSave = () => {
    props.onDismiss();
  };

  return (
    <div className="setting-container awsui-visual-refresh">
      <SpaceBetween direction="vertical" size="xs">
        <Box variant="h3">Settings</Box>
        <Toggle
          checked={!!appState.agentChatLanguage}
          description="If you have issues with translation, please contact your manager."
          disabled={true}
        >
          Chat message translation
        </Toggle>
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xxxs" alignItems="end">
            <Button variant="link" onClick={props.onDismiss}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onSave}>
              Save
            </Button>
          </SpaceBetween>
        </Box>
      </SpaceBetween>
    </div>
  );
}
